//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Import BootStrap Containers
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'


//Import Components
import ColorRow from './ColorRow'
import AddColorPalette from '../Utils/AddColorPalette'
import { changeTheme } from '../../store/actions';


//Navbar Component
const ColorPalette = (props, {store}) =>
{
    let theme = store.getState().theme;
    let userWindow = store.getState().userWindow;
    let colorArr = store.getState().colorArr;
    return (
    <Card className={`card ${theme}`}>
        
        <Card.Body className={`text-center ${theme}`}>
            <Row className="card-row">
                <Col>
                    <h5 className={`card-title ${theme}`}>Select theme and click the colored circles</h5>
                    <i className={`${theme === 'light'?userWindow.darkIcon:userWindow.lightIcon} ${theme}`}
                        onClick={() => store.dispatch(changeTheme(theme, userWindow))}
                        title='Switch theme'>
                    </i>
                </Col>
            </Row>
        </Card.Body>

        <Card.Footer className={`${theme}`}>
            <div className="color-holder"
                id='colorHolder'>
                {colorArr.map((d, i) =>
                <ColorRow key={i} 
                            {...d}/>
                )}
            </div>
        </Card.Footer>

        <Card.Body className={`text-center add-color-div ${theme}`}>
            <Row>
                <Col>
                    <AddColorPalette />
                </Col>
            </Row>
        </Card.Body>

    </Card>
    )
}

ColorPalette.contextTypes = {
    store: PropTypes.object
}

export default ColorPalette